export const skill = [
  {
    title: 'Hard',
    description: 'My technical skills include...',
    skills: [
      'Vue.js',
      'Nuxt',
      'React',
      'TypeScript',
      'JavaScript',
      'HTML5',
      'CSS3',
      'SASS',
      'Tailwind CSS',
      'Vuetify',
      'Node.js',
      'REST APIs',
      'Git',
      'GitHub',
      'GitLab',
      'Docker',
      'AWS',
      'Storybook',
      'Design Tokens',
      'Testing Library',
      'Vitest',
      'Jest',
      'GitHub Actions',
      'CI/CD',
      'ESLint',
      'Prettier',
    ],
  },
  {
    title: 'Soft',
    description: 'My personal skills include...',
    skills: [
      'Leadership',
      'Communication',
      'Problem Solving',
      'Critical Thinking',
      'Ownership',
      'Collaboration',
      'Mentoring',
      'Adaptability',
      'Continuous Learning',
      'Strategic Thinking',
      'Product Mindset',
    ],
  },
  {
    title: 'Differentials',
    description: 'My work differentials skills include...',
    skills: [
      'Frontend Architecture',
      'Design Systems',
      'Component Libraries',
      'Accessibility (WCAG)',
      'Performance Optimization',
      'Code Review',
      'Technical Leadership',
      'Agile Methodologies',
      'Clean Code',
      'Developer Experience',
      'Monorepo',
      'SEO',
    ],
  },
  {
    title: 'Idiomas',
    description: 'My language skills include...',
    skills: [
      'Portuguese - Native',
      'English — Professional Working Proficiency',
      'Spanish - Beginner',
    ],
  },
]
